import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'

import EncountersService from 'Services/encounters'

import Header from 'Components/shared/Header'
import { Select } from 'Components/shared/Select'
import { statusOptions } from 'Components/shared/SelectStatus'
import { FadedText } from 'Components/shared/Typography'
import { ownerOptions } from 'Components/shared/SelectOwner'

import { Flex } from 'lese'
import { toastWithErrorMessage } from 'Helpers/toast'
import { createModal } from 'Components/Modal'
import ContactPatient, { MessageImage } from './ContactPatient'
import Print from './Print'

const FadedTextSmall = styled(FadedText)`
  font-size: 0.8rem;
`

export default ({ encounter, updateRemarks, title }) => {
  const [statusId, setStatusId] = useState(0)
  const [ownerId, setOwnerId] = useState(null)
  const [owners, setOwners] = useState([])

  useEffect(async () => {
    if (encounter.review) {
      setStatusId(encounter.review.status)
      setOwnerId(encounter.review.userId)
    }
  }, [encounter])

  useEffect(async () => {
    if (encounter.officeId) {
      const options = await ownerOptions([encounter.officeId])
      setOwners(options)
    }
  }, [encounter.officeId])

  const updateEncounterStatus = async e => {
    const updatedEncounter = await EncountersService.updateStatus({
      encounterId: encounter.id,
      oldStatus: e.previousValue,
      newStatus: e.newValue
    }).catch(toastWithErrorMessage('Failed to update encounter status'))
    if (!updatedEncounter) return

    setStatusId(e.newValue)
    updateRemarks()
  }

  const updateEncounterOwner = async e => {
    const updatedEncounter = await EncountersService.updateOwner({
      encounterId: encounter.id,
      oldOwner: e.previousValue,
      newOwner: e.newValue
    }).catch(toastWithErrorMessage('Failed to update encounter status'))
    if (!updatedEncounter) return

    setOwnerId(e.newValue)
    updateRemarks()
  }

  return (
    <Header>
      {encounter.id && (
        <>
          <Flex separation="12px">
            <div>
              <FadedTextSmall>Sts:</FadedTextSmall>
              <Select
                minWidth={150}
                selected={statusId}
                onChange={updateEncounterStatus}
                options={statusOptions}
              />
            </div>
            <div>
              <FadedTextSmall>Revr:</FadedTextSmall>
              {owners.length > 0 && (
                <Select
                  minWidth={130}
                  selected={ownerId}
                  onChange={updateEncounterOwner}
                  options={owners}
                />
              )}
            </div>
          </Flex>
          {title}
          <Flex separation="12px" yAlign>
            <MessageImage
              src="/envelope.svg"
              title="Direct message to patient"
              onClick={() => {
                createModal(<ContactPatient tCode={encounter.tCode} />)
              }}
            />
            <Print encounter={encounter} />
          </Flex>
        </>
      )}
    </Header>
  )
}
